export default "__VITE_ASSET__2a7767ba__"